export const columns = [
  {
    name: 'RANKING',
    sortable: false,
    minWidth: '20px',
    center: true,
    sortField: 'rank',
    selector: (row) => row.rank,
    cell: (_, idx) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{idx + 1}</span>
        </div>
      </div>
    )
  },
  {
    name: 'EMOCIONES',
    sortable: false,
    minWidth: '180px',
    sortField: 'name',
    selector: (row) => row.name,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder text-left">{row.name}</span>
        </div>
      </div>
    )
  },
  {
    name: 'EPISODIOS',
    minWidth: '120px',
    center: true,
    selector: (row) => row.episodes,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.episodes}
      </span>
    )
  },
  {
    name: 'ME GUSTA',
    minWidth: '120px',
    center: true,
    selector: (row) => row.likes,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.likes}
      </span>
    )
  },
  {
    name: 'EMPEZADO',
    minWidth: '120px',
    center: true,
    selector: (row) => row.started,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.started}
      </span>
    )
  },
  {
    name: 'PORCENTAJE',
    minWidth: '150px',
    sortable: false,
    selector: (row) => row.percentage,
    cell: (row) => (
      <div className="progress" style={{ width: '100%', height: 7 }}>
        <div
          id={row._id}
          className="progress-bar"
          role="progressbar"
          style={{
            background: '#4DFF84',
            width: `${row.percentage}%`
          }}
          aria-valuenow={row.percentage}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    )
  },
  {
    name: 'COMPLETADO',
    minWidth: '150px',
    center: true,
    selector: (row) => row.finished,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.finished}
      </span>
    )
  }
];
